// extracted by mini-css-extract-plugin
export default {"addProductsDrawer":"styles_add-products-drawer__-zJMw","addProductsDrawer__uploadButton":"styles_add-products-drawer__upload-button__Fo8aa"};